import {useLocation, useNavigate} from 'react-router-dom';
import Axios, { AxiosRequestConfig } from 'axios';

import { API_URL } from '@/config';
import { useAxiosRouteStore } from '@/stores/axiosRoute';
import {useUserStore} from '@/stores/user'

export const axios = Axios.create({
  baseURL: API_URL,
});

axios.interceptors.request.use(config => {
    config.headers.Accept = 'application/json';

    // CSRFトークンをヘッダーに追加（POST/PUT/DELETE/PATCH時）
    const method = config.method?.toUpperCase();
    if (method && ['POST', 'PUT', 'DELETE', 'PATCH'].includes(method)) {
        const csrfToken = sessionStorage.getItem('csrfToken');
        if (csrfToken) {
            config.headers['X-CSRF-Token'] = csrfToken;
        }
    }

    return config
});

axios.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response?.status === 401) {
            useAxiosRouteStore.getState().setAxiosRoute('/login');
            useUserStore.getState().setUser(undefined);
        }

        // 403 Forbidden (CSRF検証失敗): トークンを破棄して再ログインへ誘導
        if (error.response?.status === 403) {
            sessionStorage.removeItem('csrfToken');
            useAxiosRouteStore.getState().setAxiosRoute('/login');
        }

        return Promise.reject(error);
    }
);

axios.defaults.withCredentials = true